module.exports = __webpack_public_path__ + "assets/img/left1.1ba68c76.png";